import { CircularProgress, Modal, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

type Props = {
  title: string;
  delay?: number;
  subtitle?: string;
  prompt?: JSX.Element;
};

export const LoadingOverlay: React.FC<Props> = ({ title, delay = 0, subtitle, prompt }) => {
  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsDisplayed(true);
    }, delay);

    return () => {
      return clearTimeout(timeout);
    };
  }, [delay]);

  if (!isDisplayed) {
    return null;
  }

  return (
    <Modal open={isDisplayed}>
      <div className="absolute inset-0 z-99 flex items-center justify-center rounded bg-gray-900 bg-opacity-25">
        <Stack spacing={3} className="max-w-2xl rounded border bg-white px-8 py-8 shadow">
          <Stack spacing={4}>
            <Stack direction="row" spacing={4} alignItems="center">
              <Typography>
                <CircularProgress size={30} color="secondary" />
              </Typography>

              <Typography variant="h2">{title}</Typography>
            </Stack>
            {subtitle && (
              <Typography variant="subtitle2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
            {prompt}
          </Stack>
        </Stack>
      </div>
    </Modal>
  );
};
